<template>
  <div class="user-selector" :class="{ collapsed: isCollapsed }">
    <el-card>
      <el-tree
        :props="props"
        :data="data"
        default-expand-all
        ref="tree"
        node-key="id" 
        show-checkbox
        @check="handleCheckChange"
        @node-contextmenu="handleRightClick"
        @node-click="handleLeftClick">
      </el-tree>
    </el-card>
    <div class="collapsible" :class="{ expand: isCollapsed, collapse: !isCollapsed}" @click="isCollapsed = !isCollapsed">
      <div><div></div></div>
      <font-awesome-icon icon="chevron-right" v-if="isCollapsed"></font-awesome-icon>
      <font-awesome-icon icon="chevron-left" v-if="!isCollapsed"></font-awesome-icon>
    </div>
  </div>
</template>

<script>
import { getUserRole, getUserTeam } from '@/utils/users'
import { nullString } from '@/utils/utils'

export default {
  props: {
    includeEveryone: Boolean
  },
  data () {
    return {
      props: {
        label: 'label',
        children: 'children'
      }
    }
  },
  methods: {
    updateStore () {
      let nodes = this.$refs.tree.getCheckedNodes()
      let users = []
      nodes.forEach(node => {
        if (node.data) {
          users.push(node.data)
        }
      })
      this.$store.commit('updateSelectedUsers', users)
    },
    handleCheckChange (node, status) {
      this.updateStore()
    },
    handleRightClick (e, node) {
      if (node.id) {
        this.$refs.tree.setCheckedKeys([node.id])
      }
      this.updateStore()
    },
    handleLeftClick (e, node) {
      if (node.data.id) {
        let checked = this.$refs.tree.getCheckedKeys()
        let index = checked.indexOf(node.data.id) // <-- Not supported in <IE9
        if (index !== -1) {
          checked.splice(index, 1)
        } else {
          checked.push(node.data.id)
        }
        this.$refs.tree.setCheckedKeys(checked)
      }
      this.updateStore()
    }
  },
  computed: {
    isCollapsed: {
      get () {
        return this.$store.getters.userSelectorIsCollapsed
      },
      set (val) {
        this.$store.commit('setUserSelectorIsCollapsed', val)
      }
    },
    data () {
      let users = this.$store.getters['users/all']
      let teams = this.$store.getters['teams/all']
      let inactiveUsers = []
      let activeUsers = []
      teams.forEach(team => {
        let children = []
        team.relationships.users.data.forEach(user => {
          let userObj = this.$store.getters['users/byId']({id: user.id})
          let role = getUserRole(userObj).attributes.name
          if (role !== 'disconnected' && !userObj.attributes.isDeleted) {
            children.push({
              label: userObj.attributes.name,
              data: userObj,
              id: userObj.id
            })
          }
        })
        if (children.length > 0) {
          activeUsers.push({
            label: team.attributes.name,
            children: children.sort(function (a, b) { return a.label.localeCompare(b.label) })
          })
        }
      })
      users.forEach(user => {
        let team = getUserTeam(user)
        let role = getUserRole(user)
        if (team.attributes.name === nullString && role.attributes.name !== 'disconnected' && !user.attributes.isDeleted && user.attributes.name !== 'System User' && user.attributes.name !== 'Unassigned' && user.attributes.name !== 'Everyone') {
          activeUsers.push({
            label: user.attributes.name,
            data: user,
            id: user.id
          })
        }
        if (role.attributes.name === 'disconnected' && !user.attributes.isDeleted) {
          inactiveUsers.push({
            label: user.attributes.name,
            data: user,
            id: user.id
          })
        }
      })
      return [{label: 'Active Users', children: activeUsers}, {label: 'Inactive Users', children: inactiveUsers}]
    }
  },
  mounted () {
    let selectedUsers = this.$store.getters.selectedUsers
    let selection = []
    selectedUsers.forEach(user => {
      selection.push(user.id)
    })
    this.$refs.tree.setCheckedKeys(selection)
  }
}
</script>

<style lang='scss'>
  .user-selector {

    .el-card {
      box-shadow: none !important;
      border-width: 0px !important;
      overflow: auto !important;
      height: 100% !important;

      .el-card__body {
        padding: 0px !important;
      }
    }
  }
</style>

<style lang='scss' scoped>
  @import '../styles/common.scss';
  .user-selector {
    width: 250px;
    min-width: 250px;
    border-width: 0px;
    border-right: 1px solid #ebeef5;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    
    &.collapsed {
      width: 0px;
      min-width: 0px;
      padding: 0px;
    }
    .collapsible {
      position: absolute;
      right: -5px;
      top: 0px;
      width: 10px;
      height: 100%;
      cursor: col-resize;
    
      > div {
        width: 10px;
        height: 50px;
        position: absolute;
        top: 50%;
        overflow: hidden;
        cursor: pointer;

        div {
          position: absolute;
          width: 40px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
        }
      }
      svg {
        font-size: 12px;
        transform: scale(1,1.3);
        position: absolute;
        top: calc(50% + 20px);
        cursor: pointer;
      }
      &.expand {

        > div {
          left: 5px;

          div {
            right: 0px;
            background-color: #f0f0f3;
          }
        }
        svg {
          margin-left: 4px;
          color: rgba(0,0,0,0.4);
        }
      }
      &.collapse {

        > div {
          left: -4px;
          width: 10px;

          div {
            border: 1px solid #e4e4e4;
            background-color: #fff;
          }
        }
        svg {
          color: rgba(0,0,0,0.25);
          margin-left: 1px;
        }
      }
    }
  }
</style>